import { Scroll } from "@lib/scroll";

export function listenForHubspotSubmit() {
  window.addEventListener("message", (event) => {
    if (
      event.data?.type === "hsFormCallback" &&
      event.data?.eventName === "onFormSubmitted"
    ) {
      console.log("submitted form");
      Scroll.toTop();
    }
  });
}
